import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { State } from './type';
import { AnalyticsProject } from '../../common/analytics/interfaces/analyticsProject';

const initialState: State = {
  commentCount: 0,
  currentProject: null,
};

const hydrate = createAction<{ project: State }>(HYDRATE);

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    updateCommentCount: (state, action: PayloadAction<number>) => {
      state.commentCount = action.payload;
    },
    updateCurrentProject: (state, action: PayloadAction<AnalyticsProject>) => {
      state.currentProject = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action) => {
      return { ...state, ...action.payload.project };
    });
  },
});

export const { updateCommentCount, updateCurrentProject } =
  projectSlice.actions;

export default projectSlice.reducer;
